import { jsxs, jsx } from 'react/jsx-runtime';
import { Space, Icon } from '@sravni/react-design-system';
import { Text } from '@sravni/react-design-system/lib/Typography';
import modules_84b8c723 from './WithIcon.module.scss.js';

var WithIcon = function (_a) {
    var text = _a.text, icon = _a.icon, color = _a.color, textColor = _a.textColor, className = _a.className;
    return (jsxs(Space, { size: 4, inline: true, className: className, children: [jsx(Icon, { size: 16, icon: icon, color: color }), jsx(Text, { uppercase: true, strong: true, size: 10, color: textColor, className: modules_84b8c723.text, children: text })] }));
};

export { WithIcon };
//# sourceMappingURL=WithIcon.js.map
